import { getApolloClient } from '../lib/getApolloClient';
import {
  BLOCK_USER,
  GET_BLOCKED_USERS_FOR_OWNER,
  UNBLOCK_USER,
} from './blockedUser.gql';
import {
  BlockedUser,
  BlockedUserOwnerType,
  UserRole,
} from '../generated/gql-types';

const getBlockedUsersForOwner = async (
  ownerId: string,
  ownerType: BlockedUserOwnerType,
  blockedUserRole?: UserRole,
): Promise<BlockedUser[]> => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_BLOCKED_USERS_FOR_OWNER,
      variables: { ownerId, ownerType, blockedUserRole },
      fetchPolicy: 'network-only',
    });
    return data.getBlockedUsersForOwner ?? [];
  } catch (error) {
    console.error('Error getting blocked users for owner:', error);
    throw error;
  }
};

const blockUser = async (
  ownerId: string,
  ownerType: BlockedUserOwnerType,
  userId: string,
  reason?: string,
): Promise<BlockedUser | null> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: BLOCK_USER,
      variables: { ownerId, ownerType, userId, reason },
    });
    return data?.blockUser ?? null;
  } catch (error) {
    console.error('Error blocking user:', error);
    throw error;
  }
};

const unblockUser = async (
  ownerId: string,
  ownerType: BlockedUserOwnerType,
  userId: string,
): Promise<boolean> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: UNBLOCK_USER,
      variables: { ownerId, ownerType, userId },
    });
    return Boolean(data?.unblockUser);
  } catch (error) {
    console.error('Error unblocking user:', error);
    throw error;
  }
};

export const blockedUserActions = {
  getBlockedUsersForOwner,
  blockUser,
  unblockUser,
};
